import React, { useEffect, useState, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import axios from 'axios';

import { apartmentReceiptDetailModelGet } from '../../models/apartments/apartmentReceiptDetail';

import {
    dataTableLanguaje, responseGet, globalSettings, setBadgeStatusGeneric, numberSet, separatorsNumbersSet, styles, validateDecimals,
    sendMessageCloseCurrentWindowAsync, buttonProcessGet, dateTimeFormatGlobalSet, languageObjGet, isUndNullEmp, awaitDelay,
} from '../../helpers/settings';
import { receiptModelGet } from '../../models/receipts/receipt';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { apartmentReceiptModelGet } from '../../models/apartments/apartmentReceipt';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'ReceiptPerApartmentDetailAdd';

const neutralValue = 0.00;
const neutralValueStr = separatorsNumbersSet({
    number: neutralValue,
    withDecimals: true,
    consoleLogErrorShow: true,
    subMethod: currentMethod,
})?.result;

export default function ReceiptPerApartmentDetailAdd({
    $ = {},
    auth = {},
    buildingBalance = neutralValue,
    setBuildingBalance = () => { },
    buildingBalanceSetAsync = async ({ balance = neutralValue, subMethod = '', }) => { },
    receipt = receiptModelGet({}),
    receiptPaymentPrint = false,
    apartment = apartmentModelGet({}),
    apartmentBalance = neutralValue,
    setApartmentBalance = () => { },
    apartmentReceipt = apartmentReceiptModelGet({}),
    setApartmentReceipt = () => { },
    apartmentReceiptDetails = [],
    setApartmentReceiptDetails = () => { },
    dtConceptsId = '',
    concepts = [],
    conceptsDt = () => { },
    conceptsGetAsync = async ({ subMethod = '', }) => { },
    dtApartmentsId = '',
    dtApartmentsRowIndex = 0,
    dtReceiptsId = '',
    dtReceiptsRowIndex = 0,
    dtReceiptId = '',
    showModal = false,
    setShowModal = () => { },
    btnIsDisable = false,
    btnARPAddIsDisabled = false,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let concept = {};
    let dataObj = {};
    let headerObj = {};
    //let conceptId = '';
    const [conceptId, setConceptId] = useState('');
    const [conceptQuantity, setConceptQuantity] = useState(neutralValue);
    const [conceptPrice, setConceptprice] = useState(neutralValue);
    const [quantityError, setQuantityError] = useState('');
    const [priceError, setPriceError] = useState('');
    //#region others
    const controls = {
        buttons: {
            // detailAdd: {
            //     id: 'btnApartmentReceiptdetailDetailAdd',
            //     className: 'btn btn-outline-info',
            // },
            // print: {
            //     id: 'btnApartmentReceiptdetailPrint',
            //     className: 'btn btn-outline-secondary mx-1',
            // },
            save: {
                id: 'btnApartmentReceiptdetailSave',
                className: 'btn btn-outline-warning',
            },
            back: {
                id: 'btnApartmentReceiptdetailBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnApartmentReceiptdetailClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        inputs: {
            quantity: {
                id: 'inputApartmentReceiptdetailQuantity',
                className: 'form-control text-right',
            },
            price: {
                id: 'inputApartmentReceiptdetailPrice',
                className: 'form-control text-right',
            },
        },
        dataTables: {
            expenseConcepts: {
                buttons: {
                    // create: {
                    //     className: 'btn btn-outline-success float-right btn-sm',
                    //     id: 'btnDtExpenseConceptsCreate',
                    // },
                },
                icons: {
                    // create: {
                    //     id: 'iconDtExpenseConceptsCreate',
                    //     className: globalSettings?.icons?.plusCircle,
                    // },
                },
                inputs: {
                    search: {
                        id: `${dtConceptsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtConceptsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    // create: {
                    //     id: 'spDtExpenseConceptsCreate',
                    //     className: '',
                    // },
                },
            },
            // apartmentReceiptDetails: {
            //     buttons: {
            //         // create: {
            //         //     className: 'btn btn-outline-success float-right btn-sm',
            //         //     id: 'btnDtExpenseConceptsCreate',
            //         // },
            //     },
            //     icons: {
            //         // create: {
            //         //     id: 'iconDtExpenseConceptsCreate',
            //         //     className: globalSettings?.icons?.plusCircle,
            //         // },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtReceiptId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtReceiptId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         // create: {
            //         //     id: 'spDtExpenseConceptsCreate',
            //         //     className: '',
            //         // },
            //     },
            // },
        },
        icons: {
            // detailAdd: {
            //     id: 'icoApartmentReceiptdetailDetailAdd',
            //     className: globalSettings?.icons?.listOl,
            // },
            // print: {
            //     id: 'icoApartmentReceiptdetailPrint',
            //     className: globalSettings?.icons?.print,
            // },
            save: {
                id: 'icoApartmentReceiptdetailSave',
                className: globalSettings?.icons?.save,
            },
            back: {
                id: 'icoApartmentReceiptdetailBack',
                className: globalSettings?.icons?.arrowAltCircleLeft,
            },
            close: {
                id: 'icoApartmentReceiptdetailClose',
                className: globalSettings?.icons?.print,
            },
        },
        spinners: {
            // detailAdd: {
            //     id: 'spApartmentReceiptdetailDetailAdd',
            //     className: '',
            // },
            // print: {
            //     id: 'spApartmentReceiptdetailPrint',
            //     className: '',
            // },
            save: {
                id: 'spApartmentReceiptdetailSave',
                className: '',
            },
            back: {
                id: 'spApartmentReceiptdetailBack',
                className: '',
            },
            close: {
                id: 'spApartmentReceiptdetailClose',
                className: '',
            },
        },
    };
    //#endregion others
    //#endregion variables

    //#region apartment receipt
    //#region old code
    // const receiptApartmentAddDetailGetAsync = async ({ e = {}, subMethod = '', }) => {
    //     const currentMethod = 'receiptApartmentAddDetailGetAsync';
    //     let response = responseGet();
    //     try {
    //         if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
    //             e?.preventDefault();
    //         }

    //         controlsStatusSet({ processType: 1, subMethod: currentMethod, });

    //         //#region concepts get
    //         response = await conceptsGetAsync({ subMethod: currentMethod, });
    //         if (!response?.isSuccess || response?.isWarning) {
    //             return;
    //         }
    //         //#endregion concepts get

    //         setShowModal(true);

    //         controlsStatusSet({ processType: 0, subMethod: currentMethod, });
    //     } catch (ex) {
    //         controlsStatusSet({ processType: 0, subMethod: currentMethod, });
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync({
    //             msgType: response?.msgType,
    //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
    //             closeWindow: false,
    //             urlGoTo: response?.urlGoTo,
    //             auth: auth,
    //             isLogout: false,
    //             languageId: languageObj?.id,
    //             subMethod: currentMethod,
    //         });
    //     }
    // }
    //#endregion old code

    const receiptApartmentAddDetailPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'receiptApartmentAddDetailPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let dtRowObj = {};
            let conceptTotalLocal = {};
            const processValue = {
                process: {
                    edit: false,
                    details: false,
                    delete: false,
                },
            };
            let buildingBalanceLocal = neutralValue;
            let apartmentBalanceLocal = neutralValue;
            let buildingBalanceTotalLocal = neutralValue;
            let apartmentBalanceTotalLocal = neutralValue;
            let apartmentReceiptLocal = {
                ...apartmentReceiptModelGet({}),
                ...processValue,
            };
            let apartmentReceiptDetailLocal = {
                ...apartmentReceiptDetailModelGet({}),
                ...processValue,
            };
            //#endregion variables

            //#region initialize
            //#endregion initialize

            //#region form data validate
            response = await validateFormDataAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion form data validate

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region create apartment receipt (detail)
            apartmentReceiptDetailLocal = apartmentReceiptDetailModelGet({
                buildingId: apartmentReceipt?.buildingId,
                apartmentId: apartmentReceipt?.apartmentId,
                receiptId: apartmentReceipt?.receiptId,
                apartmentReceiptId: apartmentReceipt?.id,
                expenseConceptId: concept?.id,
                userId: auth?.user?.uid
            });
            apartmentReceiptDetailLocal.quantity = concept?.quantity;
            apartmentReceiptDetailLocal.price = concept?.price;

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                apartmentReceiptDetail: apartmentReceiptDetailLocal,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlApartmentReceiptDetails}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            apartmentReceiptDetailLocal = response?.result?.apartmentReceiptDetail || {};
            //#endregion create apartment receipt (detail)

            //#region update apartment receipt (Balance, total)
            apartmentReceiptLocal = response?.result?.apartmentReceipt || {};
            conceptTotalLocal = response?.result?.conceptTotal;
            setApartmentReceipt(apartmentReceiptLocal);
            setApartmentReceiptDetails([...apartmentReceiptDetails, apartmentReceiptDetailLocal]);
            //#endregion update apartment receipt (Balance, total)

            //#region add record to dtReceipt
            //#region variables
            dtRowObj = {
                quantity: separatorsNumbersSet({
                    number: apartmentReceiptDetailLocal?.quantity,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                price: separatorsNumbersSet({
                    number: apartmentReceiptDetailLocal?.price,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                total: separatorsNumbersSet({
                    number: conceptTotalLocal,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
            };
            //#endregion variables

            //#region methods
            $(`#${dtReceiptId}`)?.DataTable()?.row?.add([
                concept.description,
                dtRowObj?.quantity,
                dtRowObj?.price,
                dtRowObj?.total,
                buttonProcessGet({
                    id: apartmentReceiptDetailLocal?.id,
                    description: concept?.description,
                    showDetails: false,
                    labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                    enabledDetails: false,
                    //showEdit: apartmentReceiptDetailLocal?.process?.edit, //true,
                    showEdit: true,
                    labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                    //enabledEdit: apartmentReceiptDetailLocal?.process?.edit, //true,
                    enabledEdit: true,
                    //showDelete: apartmentReceiptDetailLocal?.process?.delete, //true,
                    showDelete: true,
                    labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                    //enabledDelete: apartmentReceiptDetailLocal?.process?.delete, //true,
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion methods
            //#endregion add record to dtReceipt

            //#region update record dtReceipts
            //#region variables
            dtRowObj = {
                receiptNumberApartment: apartmentReceiptLocal?.receiptNumberApartment,
                from: dateTimeFormatGlobalSet({
                    date: receipt?.from,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                total: separatorsNumbersSet({
                    number: apartmentReceiptLocal?.total,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                balance: setBadgeStatusGeneric({
                    type: apartmentReceiptLocal?.balance > neutralValue ? 1 : 0,
                    value: separatorsNumbersSet({
                        number: apartmentReceiptLocal?.balance,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                    subMethod: currentMethod,
                }),
            };
            //#endregion variables

            //#region methods
            $(`#${dtReceiptsId}`)?.DataTable()?.row(dtReceiptsRowIndex)?.data?.([
                dtRowObj?.receiptNumberApartment,
                dtRowObj?.from,
                dtRowObj?.total,
                dtRowObj?.balance,
                buttonProcessGet({
                    id: apartmentReceipt?.id,
                    description: apartment?.identifier,
                    showDetails: true,
                    labelDetails: globalSettings?.labels?.receiptDetail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: false,
                    labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                    enabledEdit: false,
                    showDelete: false,
                    labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                    enabledDelete: false,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);

            apartmentBalanceLocal = numberSet({
                number: apartmentBalance,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            apartmentBalanceTotalLocal = numberSet({
                number: (apartmentBalanceLocal + conceptTotalLocal),
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            setApartmentBalance(apartmentBalanceTotalLocal);
            //#endregion methods
            //#endregion update record dtReceipts

            //#region update record dtApartments
            //#region variables
            dtRowObj = {
                balance: separatorsNumbersSet({
                    number: apartmentBalanceTotalLocal,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
            };
            //#endregion variables

            //#region methods
            $(`#${dtApartmentsId}`)?.DataTable()?.row(dtApartmentsRowIndex)?.data?.([
                apartment?.floor,
                apartment?.identifier,
                dtRowObj?.balance,
                buttonProcessGet({
                    id: apartment?.id,
                    description: apartment?.identifier,
                    showDetails: true,
                    labelDetails: globalSettings?.labels?.viewReceipts?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: false,
                    labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                    enabledEdit: false,
                    showDelete: false,
                    labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                    enabledDelete: false,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion methods
            //#endregion update record dtApartments

            //#region update building balance
            buildingBalanceLocal = numberSet({
                number: buildingBalance,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            buildingBalanceTotalLocal = numberSet({
                number: (buildingBalanceLocal + conceptTotalLocal),
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            setBuildingBalance(buildingBalanceTotalLocal);

            response = await buildingBalanceSetAsync({
                balance: buildingBalanceTotalLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                return;
            }
            //#endregion update building balance

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const apartmentReceiptPrintAsync = async ({ e = {}, subMethod = '', }) => {
    //     const currentMethod = 'apartmentReceiptPrintAsync';
    //     let response = responseGet();
    //     try {
    //         if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
    //             e?.preventDefault();
    //         }

    //         controlsStatusSet({ processType: 2, subMethod: currentMethod, });
    //         await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });

    //         window.open = (`/${globalSettings?.app?.reports?.receiptPrint}/${apartmentReceipt?.id}`, '_blank');

    //         controlsStatusSet({ processType: 0, subMethod: currentMethod, });
    //     } catch (ex) {
    //         controlsStatusSet({ processType: 0, subMethod: currentMethod, });
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync({
    //             msgType: response?.msgType,
    //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
    //             closeWindow: false,
    //             urlGoTo: response?.urlGoTo,
    //             auth: auth,
    //             isLogout: false,
    //             languageId: languageObj?.id,
    //             subMethod: currentMethod,
    //         });
    //     }
    // }
    //#endregion old code
    //#endregion apartment receipt

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            response = await dataTableConceptsSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await queryCodeSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTableConceptsSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTableConceptsSetAsync';
        let response = responseGet();
        try {
            $(`#${dtConceptsId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: globalSettings?.labels?.concept?.[languageObj?.id], width: '95%', },
                    { title: globalSettings?.labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: conceptsDt,
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                //lengthChange: false,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtConceptsId}_wrapper .col-md-6:eq(0)`);
            });
            //queryCodeSetAsync();
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let rowIndex = 0;
            let isChecked = false;
            //#endregion variables

            //#region methods
            $(`#${dtConceptsId} tbody`)?.on('click', 'tr', 'td', function (e) {
                rowIndex = $(`#${dtConceptsId}`)?.DataTable()?.row(this)?.index();
                if (!isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    isChecked = e?.target?.checked || false;
                    if (!isUndNullEmp({ data: id, subMethod: currentMethod, })?.result) {
                        switch (isChecked) {
                            case true:
                                //conceptId = id;
                                setConceptId(id);
                                break;
                            default:
                                break;
                        }
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            //#region body show modal set
            if (isModalClose) {
                setConceptQuantity(neutralValue);
                setConceptprice(neutralValue);

                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }
            //#endregion body show modal set

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const validateFormDataAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'validateFormDataAsync';
        let response = responseGet();;
        try {
            //#region methods
            if (isUndNullEmp({ data: conceptId, subMethod: currentMethod, })?.result) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: globalSettings?.messages?.youMustSelectConcept?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                response.isWarning = true;
                return response;
            }

            concept = concepts?.find(({ id }) => id === conceptId);
            concept.quantity = numberSet({
                number: conceptQuantity,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            concept.price = numberSet({
                number: conceptPrice,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;

            if (concept?.quantity <= neutralValue) {
                setQuantityError(`${globalSettings?.messages?.mustBeGreaterThan?.[languageObj?.id]} <b>${neutralValueStr}</b>`);
                response.isWarning = true;
            }

            if (concept?.price <= neutralValue) {
                setPriceError(`${globalSettings?.messages?.mustBeGreaterThan?.[languageObj?.id]} <b>${neutralValueStr}</b>`);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.quantity?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.price?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.expenseTemplateTotal?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.apartmentReceiptDetails?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType <= 2));
            // $(`#${controls?.dataTables?.apartmentReceiptDetails?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType <= 2));

            $(`#${controls?.dataTables?.expenseConcepts?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.expenseConcepts?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                // if (processType <= 2) {
                //     $(`#${controls?.buttons?.detailAdd?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                //     $(`#${controls?.buttons?.print?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                // } else if (processType >= 3) {
                //     $(`#${controls?.buttons?.save?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                //     $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                //     $(`#${controls?.buttons?.close?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                // }
                $(`#${controls?.buttons?.save?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: `form - onLoad: ${currentMethod}` });
    }, [showModal]);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            {/* <button id={controls?.buttons?.detailAdd?.id}
                className={controls?.buttons?.detailAdd?.className}
                disabled={btnIsDisable || !receipt?.isOpen || receipt?.balance !== receipt?.total}
                onClick={(e) => receiptApartmentAddDetailGetAsync({ e: e, subMethod: 'btn - apartmentReceiptDetialAdd', })}
                tooltip='tooltip'
                title={globalSettings?.labels?.addDetail}
                type='button'>
                <i id={controls?.icons?.detailAdd?.id} className={controls?.icons?.detailAdd?.className} /> <span id={controls?.spinners?.detailAdd?.id} className='' aria-hidden='true'></span>
            </button>
            <button id={controls?.buttons?.print?.id}
                className={controls?.buttons?.print?.className}
                disabled={btnIsDisable || receipt?.isOpen || receipt?.balance > neutralValue}
                onClick={(e) => apartmentReceiptPrintAsync({ e: e, subMethod: 'btn - apartmentReceip', })}
                title={globalSettings?.labels?.printReceipt}
                type='button'>
                <i id={controls?.icons?.print?.id} className={controls?.icons?.print?.className} /> <span id={controls?.spinners?.print?.id} className='' aria-hidden='true'></span>
            </button> */}
            <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
                <Modal.Header>
                    <Modal.Title>
                        <img alt={globalSettings?.labels?.concept?.[languageObj?.id]}
                            src={globalSettings?.images?.expenseConceptsLogo}
                            style={styles?.cardHeaderLogo}>
                        </img> - {globalSettings?.labels?.add?.[languageObj?.id]}
                    </Modal.Title>
                    <button id={controls?.buttons?.close?.id}
                        className={controls?.buttons?.close?.className}
                        type='button'
                        data-dismiss='modal'
                        aria-label='Close'
                        onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                    </button>
                </Modal.Header>
                <form onSubmit={(e) => receiptApartmentAddDetailPostAsync({ e: e, subMethod: 'form - onSubmit', })}>
                    <Modal.Body>
                        {/* <form onSubmit={(e) => receiptApartmentAddDetailPostAsync(e)}> */}
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <div className='input-group mb-3'>
                                        <input id={controls?.inputs?.quantity?.id}
                                            className={controls?.inputs?.quantity?.className}
                                            onChange={(e) => setConceptQuantity(
                                                validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - quantity', })
                                            )}
                                            onFocus={() => setQuantityError('')}
                                            placeholder={globalSettings?.labels?.quantity?.[languageObj?.id]}
                                            tooltip='tooltip'
                                            title={globalSettings?.labels?.quantity?.[languageObj?.id]}
                                            value={conceptQuantity || '0.00'} />
                                        <div className='input-group-append'>
                                            <div className='input-group-text'>
                                                <span className={globalSettings?.icons?.sortNumericUpAlt} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(quantityError)}</div>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <div className='input-group mb-3'>
                                        <input id={controls?.inputs?.price?.id}
                                            className={controls?.inputs?.price?.className}
                                            onChange={(e) => setConceptprice(
                                                validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - price', })
                                            )}
                                            onFocus={() => setPriceError('')}
                                            placeholder={globalSettings?.labels?.price?.[languageObj?.id]}
                                            tooltip='tooltip'
                                            title={globalSettings?.labels?.price?.[languageObj?.id]}
                                            value={conceptPrice || '0.00'} />
                                        <div className='input-group-append'>
                                            <div className='input-group-text'>
                                                <span className={globalSettings?.icons?.moneyBillWave} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(priceError)}</div>
                                </div>
                            </div>
                        </div>

                        <div className='row '>
                            <div className='col-md-6'>

                            </div>
                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <ul className='list-unstyled text-muted text-right'>
                                        <li>{globalSettings?.labels?.subTotal?.[languageObj?.id]}:  {
                                            HtmlParser(
                                                setBadgeStatusGeneric({
                                                    type: 1,
                                                    value: separatorsNumbersSet({
                                                        //number: parseFloat(conceptQuantity * conceptPrice)?.toFixed(globalSettings.numberPositions.decimalPlaces),
                                                        number: numberSet({
                                                            number: (conceptQuantity * conceptPrice),
                                                            type: 'd',
                                                            languageId: languageObj?.id,
                                                            subMethod: 'lbl - subTotal',
                                                        })?.result,
                                                        withDecimals: true,
                                                        consoleLogErrorShow: true,
                                                        subMethod: 'lbl - subTotal',
                                                    })?.result,
                                                    subMethod: 'lbl - subTotal',
                                                })
                                            )
                                        }
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-md-12'>
                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                    <table id={dtConceptsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                </div>
                            </div>
                        </div>

                        {/* <div className='form-group text-right'>
                            <button className='btn btn-outline-warning'
                                tooltip='tooltip'
                                title={globalSettings?.labels?.add?.[languageObj?.id]}
                                type='submit'>
                                <i className={globalSettings?.icons?.save}></i>
                            </button>
                            <button className='btn btn-outline-success mx-1'
                                tooltip='tooltip'
                                title={globalSettings?.labels?.close?.[languageObj?.id]}
                                type='reset'
                                onClick={() => defaultValueSetAsync(true)}>
                                <i className={globalSettings?.icons?.arrowAltCircleLeft}></i>
                            </button>
                        </div> */}
                        {/* </form> */}
                    </Modal.Body>
                    <Modal.Footer className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            tooltip='tooltip'
                            title={globalSettings?.labels?.add?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={globalSettings?.labels?.close?.[languageObj?.id]}
                            type='button'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </div>
    )
}